import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { NotificationRulesTable } from "@/features/notification-rules/components/NotificationRulesTable"

export const Route = createFileRoute("/_authed/notifications")({
  // Org-scoped kullanıcıya AÇIK (2026-08-04). Kurallar oluşturan org'a damgalanıyor
  // (NotificationRule.OrgId) ve backend liste/detay/yazma uçlarını subtree'ye scope'luyor;
  // sahipsiz eski kayıtlar yalnız admin'e görünür.
  component: NotificationRulesPage,
})

function NotificationRulesPage() {
  const { t } = useTranslation("rules")
  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="border-b border-ok-border px-6 py-4">
        <h1 className="text-lg font-semibold tracking-tight">{t("title")}</h1>
        <p className="text-xs text-ok-foreground-muted">{t("subtitle")}</p>
      </div>
      <NotificationRulesTable />
    </div>
  )
}
